// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/musterteile/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const musterteileDE: PageEntry = {
  id: "post.musterteile",
  locale: "de",
  slug: "musterteile",
  seo: {
    title: "Glossar: Musterteile einfach erklärt | Dietz GmbH",
    description: "Musterteile sind physische Exemplare oder Komponenten, die während des Musterentwicklungs- und -erstellungsprozesses hergestellt werden. Diese Teile dienen als repräsentative Model",
  },
  type: "post",
  h1: "Glossar: Musterteile einfach erklärt",
  intro: "Musterteile sind physische Exemplare oder Komponenten, die während des Musterentwicklungs- und -erstellungsprozesses hergestellt werden. Diese Teile dienen als repräsentative Modelle für das Endprodukt und werden verwendet, um Designaspekte, Funktionalität und Qualität zu überprüfen. Musterteile können in verschiedenen Industriezweigen vorkommen, von der Automobilindustrie bis zur Elektronikproduktion. Die sorgfältige Herstellung und Überprüfung von Musterteilen ist entscheidend, um sicherzustellen, dass das endgültige Produkt den Anforderungen und Erwartungen entspricht.",
  blocks: [

  ],
};
